<script setup lang="ts">
import { useCoursesStore } from '~~/stores/courses'

const coursesStore: Record<string, any> = useCoursesStore()
const courseDetail = computed(() => coursesStore?.state?.courseDetail)
const { addCdnToUrl } = useFormatUrlCdn()
</script>

<template>
  <section id="kursus-detail__fasilitator" class="kursus-detail__fasilitator">
    <h2 class="info-title">Fasilitator</h2>

    <template v-if="courseDetail?.data?.facilitatorDetails?.length">
      <div
        v-for="facilitator in courseDetail?.data?.facilitatorDetails"
        :key="facilitator.id"
        class="fasilitator-wrapper"
      >
        <a-space class="mb-4">
          <a-avatar
            v-if="facilitator.imageURL"
            :size="98"
            :src="addCdnToUrl(facilitator.imageURL)"
            style="background-color: #f5f5f5"
          />
          <a-avatar v-else :size="98">
            <template #icon>
              <UserOutlined />
            </template>
          </a-avatar>

          <div>
            <h3 class="fasilitator-name">
              {{ facilitator?.user?.fullName ?? '-' }}
            </h3>
            <p class="fasilitator-role">{{ facilitator?.role ?? '-' }}</p>
          </div>
        </a-space>

        <p class="fasilitator-comment">
          {{ facilitator?.description ?? '-' }}
        </p>
      </div>
    </template>
  </section>
</template>

<style lang="scss">
@use './styles.scss';
</style>
